import React, { useState } from 'react';

import { Box, Typography, LinearProgress } from '@mui/material';
import { useInterval } from 'react-use';

const LinearProgressWithLabel = props => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant='determinate' {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant='body2' color='text.secondary'>{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
};

const FakeProgress = ({ finished = false }) => {
  const texts = {
    0: 'Enregistrement de vos informations...',
    10: 'Génération des documents...',
    50: 'Signature des documents...',
    75: 'Finalisation...',
  };

  const [progress, setProgress] = useState(0);
  const [currentText, setText] = useState(texts[0]);

  useInterval(() => {
    setProgress(progress + 2.5);
    if (texts[progress]) {
      setText(texts[progress]);
    }
    if (progress >= 100) {
      setProgress(0);
    }
  }, 800);

  return finished ? (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ textAlign: 'center', marginBottom: '10px' }}>
        <Typography variant='body2'>Terminé ! Redirection en cours...</Typography>
      </Box>
      <LinearProgressWithLabel color='success' value={100} />
    </Box>
  ) : (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ textAlign: 'center', marginBottom: '10px' }}>
        <Typography variant='body2'>{currentText}</Typography>
      </Box>
      <LinearProgressWithLabel color='success' value={progress} />
    </Box>
  );
};

export default FakeProgress;
